import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as B } from "../../_mixins/use-rtl.js";
import E from "./styles/radio.cssr.js";
import { setup as F, radioBaseProps as I } from "./use-radio.js";
import c from "../../_mixins/use-theme.js";
import { createKey as l } from "../../_utils/cssr/index.js";
import O from "../../_mixins/use-config.js";
import { useThemeClass as j } from "../../_mixins/use-css-vars-class.js";
import { resolveWrappedSlot as H } from "../../_utils/vue/resolve-slot.js";
import T from "../styles/light.js";
import { defineComponent as V, computed as n, h as s } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const L = Object.assign(Object.assign({}, c.props), I), Z = V({
  name: "Radio",
  props: L,
  setup(o) {
    const e = F(o), d = c("Radio", "-radio", E, T, o, e.mergedClsPrefix), a = n(() => {
      const {
        mergedSize: {
          value: t
        }
      } = e, {
        common: {
          cubicBezierEaseInOut: b
        },
        self: {
          boxShadow: f,
          boxShadowActive: p,
          boxShadowDisabled: v,
          boxShadowFocus: g,
          boxShadowHover: C,
          color: R,
          colorDisabled: x,
          colorActive: S,
          textColor: w,
          textColorDisabled: z,
          dotColorActive: $,
          dotColorDisabled: _,
          labelPadding: D,
          labelLineHeight: k,
          labelFontWeight: P,
          [l("fontSize", t)]: y,
          [l("radioSize", t)]: A
        }
      } = d.value;
      return {
        "--n-bezier": b,
        "--n-label-line-height": k,
        "--n-label-font-weight": P,
        "--n-box-shadow": f,
        "--n-box-shadow-active": p,
        "--n-box-shadow-disabled": v,
        "--n-box-shadow-focus": g,
        "--n-box-shadow-hover": C,
        "--n-color": R,
        "--n-color-active": S,
        "--n-color-disabled": x,
        "--n-dot-color-active": $,
        "--n-dot-color-disabled": _,
        "--n-font-size": y,
        "--n-radio-size": A,
        "--n-text-color": w,
        "--n-text-color-disabled": z,
        "--n-label-padding": D
      };
    }), {
      inlineThemeDisabled: r,
      mergedClsPrefixRef: h,
      mergedRtlRef: m
    } = O(o), u = B("Radio", m, h), i = r ? j("radio", n(() => e.mergedSize.value[0]), a, o) : void 0;
    return Object.assign(e, {
      rtlEnabled: u,
      cssVars: r ? void 0 : a,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    });
  },
  render() {
    const {
      $slots: o,
      mergedClsPrefix: e,
      onRender: d,
      label: a
    } = this;
    return d == null || d(), s("label", {
      class: [`${e}-radio`, this.themeClass, this.rtlEnabled && `${e}-radio--rtl`, this.mergedDisabled && `${e}-radio--disabled`, this.renderSafeChecked && `${e}-radio--checked`, this.focus && `${e}-radio--focus`],
      style: this.cssVars
    }, s("div", {
      class: `${e}-radio__dot-wrapper`
    }, " ", s("div", {
      class: [`${e}-radio__dot`, this.renderSafeChecked && `${e}-radio__dot--checked`]
    }), s("input", {
      ref: "inputRef",
      type: "radio",
      class: `${e}-radio-input`,
      value: this.value,
      name: this.mergedName,
      checked: this.renderSafeChecked,
      disabled: this.mergedDisabled,
      onChange: this.handleRadioInputChange,
      onFocus: this.handleRadioInputFocus,
      onBlur: this.handleRadioInputBlur
    })), H(o.default, (r) => !r && !a ? null : s("div", {
      ref: "labelRef",
      class: `${e}-radio__label`
    }, r || a)));
  }
});
export {
  Z as default,
  L as radioProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/radio/src/Radio.js
// module id = 86
// module chunks = 67